import _ from 'underscore';
import $ from 'jquery';

export default class NewsletterRecipientsPending {
  constructor($scope, $timeout, NewsletterService) {
    $scope.tabs = [
      {
        title: 'Ready to Send',
        recipients: []
      }
    ];

    $scope.set_selected_tab = function(index) {
      $scope.selected_tab = index;
    };

    $scope.check_items = function(tab_index, property) {
      _.each($scope.tabs[tab_index].recipients, function(recipient) {
        recipient[property] = $scope.tabs[tab_index].checked;
      });
    };

    $scope.load_recipients = function() {
      for (var i = 0; i < $scope.tabs.length; i++)
        $scope.tabs[i].recipients = [];
      $scope.loading = true;
      NewsletterService.get_recipients(window.newsletter.id, 1).success(function(data) {
        _.each(data.recipients, function(recipient) {
          $scope.allocate_recipient(recipient);
        });
        $scope.loading = false;
      });
    };

    $scope.allocate_recipient = function(recipient) {
      for (var i = 0; i < $scope.tabs.length; i++)
        $scope.remove_tab_recipient(i, recipient);
      if (recipient.is_pending) {
        $scope.add_tab_recipient(0, recipient);
      }
    };

    $scope.add_tab_recipient = function(index, recipient) {
      if (_.indexOf($scope.tabs[index].recipients, recipient) < 0)
        $scope.tabs[index].recipients.push(recipient);
    };

    $scope.remove_tab_recipient = function(index, recipient) {
      var recipient_index = _.indexOf($scope.tabs[index].recipients, recipient);
      if (recipient_index >= 0)
        $scope.tabs[index].recipients.splice(recipient_index, 1);
    };


    $scope.select_contacts = function(recipient) {
      $scope.dialog_select_contacts_recipient = recipient;
      $.fancybox($('div#select_recipient_contacts'), {
        padding: '5',
        openEffect: 'elastic',
        closeEffect: 'elastic',
        openSpeed: '700',
        closeSpeed: '300',
        topRatio: 0.15,
        scrolling: 'no'
      });
    };

    $scope.save_contacts = function() {
      $scope.saving_contacts = true;
      var recipient = $scope.dialog_select_contacts_recipient;
      var contacts = _.pluck(_.where(recipient.contacts, {
        checked: true
      }), 'id');
      NewsletterService.set_recipient_contacts(recipient.id, contacts).success(function(data) {
        if (data.success) {
          $scope.saving_contacts = false;
          $.fancybox.close();
        }
      });
    };

    $scope.auto_select_contacts = function(recipient) {
      recipient.auto_selecting_contacts = true;
      NewsletterService.auto_select_contacts(recipient.id).success(function(data) {
        if (data.success) {
          recipient.auto_selecting_contacts = false;
          recipient.contacts = data.contacts;
        }
      });
    };

    $scope.mass_auto_select_contacts = function(index) {
      if (index === null) {
        $scope.auto_select_recipients = _.where($scope.tabs[0].recipients, {
          checked_send: true
        });
        if ($scope.auto_select_recipients.length > 0)
          $scope.mass_auto_select_contacts(0);
      } else {
        var recipient = $scope.auto_select_recipients[index];
        recipient.auto_selecting_contacts = true;
        if (recipient.contacts.length > 0) {
          NewsletterService.auto_select_contacts(recipient.id).success(function(data) {
            if (data.success) {
              recipient.auto_selecting_contacts = false;
              recipient.contacts = data.contacts;
              if (index < $scope.auto_select_recipients.length - 1)
                $scope.mass_auto_select_contacts(index + 1);
            }
          });
        } else {
          recipient.auto_selecting_contacts = false;
          if (index < $scope.auto_select_recipients.length - 1)
            $scope.mass_auto_select_contacts(index + 1);
        }
      }
    };

    $scope.mass_select_contacts = function(index) {
      if (index === null) {
        $scope.mass_select_recipients = _.where($scope.tabs[0].recipients, {
          checked_send: true
        });
        if ($scope.mass_select_recipients.length > 0)
          $scope.mass_select_contacts(0);
      } else {
        var recipient = $scope.mass_select_recipients[index];
        var contacts = _.pluck(recipient.contacts, 'id');
        recipient.auto_selecting_contacts = true;
        if (recipient.contacts.length > 0) {
          NewsletterService.set_recipient_contacts(recipient.id, contacts).success(function(data) {
            if (data.success) {
              recipient.auto_selecting_contacts = false;
              recipient.contacts = data.contacts;
              if (index < $scope.mass_select_recipients.length - 1)
                $scope.mass_select_contacts(index + 1);
            }
          });
        } else {
          recipient.auto_selecting_contacts = false;
          if (index < $scope.mass_select_recipients.length - 1)
            $scope.mass_select_contacts(index + 1);
        }
      }
    };

    $scope.send = function(recipient) {
      recipient.sending = true;
      NewsletterService.send_email(window.newsletter.id, recipient.id, $scope.test_send, $scope.test_send_email).success(function(data) {
        if (data.success) {
          recipient.sending = false;
          recipient.is_pending = false;
          $scope.allocate_recipient(recipient);
        }
      });
    };

    $scope.mass_send = function(index) {
      if (index === null) {
        $scope.mass_send_recipients = _.where($scope.tabs[0].recipients, {
          checked_send: true
        });
        if ($scope.mass_send_recipients.length > 0)
          $scope.mass_send(0);
      } else {
        var recipient = $scope.mass_send_recipients[index];
        if (_.where(recipient.contacts, {checked: true}).length > 0) {
          recipient.sending = true;
          NewsletterService.send_email(window.newsletter.id, recipient.id, $scope.test_send, $scope.test_send_email).success(function(data) {
            if (data.success) {
              recipient.sending = false;
              recipient.is_pending = false;
              $scope.allocate_recipient(recipient);
              if (index < $scope.mass_send_recipients.length - 1)
                $scope.mass_send(index + 1);
            }
          });
        } else {
          if (index < $scope.mass_send_recipients.length - 1)
            $scope.mass_send(index + 1);
        }
      }
    };

    $scope.quick_search = function(tab_index) {
      window.filter_table('table.tab' + tab_index, $scope.tabs[tab_index].query);
    };

    $scope.$on('load_newsletter_recipients', function(/*event, args*/) {
      $scope.load_recipients();
    });

    $scope.init = function() {
      $scope.selected_tab = 0;
      $scope.newsletter = window.newsletter;
      $scope.current_page = 'recipients_pending';
      $scope.test_send = true;
      $scope.test_send_email = 'p.tsolpagas@epsilon-paper.com';
      $scope.load_recipients();
      $scope._ = _;
    };

    $scope.init();
  }
}

NewsletterRecipientsPending.$inject = ['$scope', '$timeout', 'NewsletterService'];



// WEBPACK FOOTER //
// ./front/js/admin/controllers/newsletter-recipients-pending.ctrl.js